export default "__VITE_ASSET__CpZt3$jV__"